module.exports = __webpack_public_path__ + "img/icon_map_13_off_001.befe88e8.png";